<template>
    <div>
        <a-card style="width: 100%;">
            <a-row
                :gutter="24"
                type="flex"
                justify="start"
                style="margin-bottom: 16px;"
            >
                <a-col
                    ><a-input
                        placeholder="请搜索弹幕内容或人员姓名"
                        style="width: 200px;"
                        v-model="params.keywords"
                        @blur="askDatas"
                        allowClear
                        @onSearch="askDatas"
                        @keyup.enter="askDatas"
                /></a-col>
                <a-col>
                    <a-select
                        placeholder="请选择部门"
                        style="width: 200px;"
                        @change="askDataing"
                        allowClear
                        v-model="params.department_id"
                    >
                        <a-select-opt-group :label="item.name" v-for="item in departmentlist"
                                :key="item.id">
                            <a-select-option
                                v-for="items in item.children"
                                :key="items.id"
                                :value="items.id"
                                >{{ items.name }}</a-select-option
                            >
                        </a-select-opt-group>
                    </a-select>
                </a-col>
                <a-col>
                    <a-range-picker
                        v-model="dateaskDatas"
                        @change="dateaskData"
                    />
                </a-col>
            </a-row>
            <a-table
                :columns="columns"
                :dataSource="data"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="handleTableChange"
            >
                <span slot="status" slot-scope="text, record">
                    <a-button type="danger" @click="clickdel(record)">
                        删除
                    </a-button>
                </span>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import {
    bulletChatindex,
    bulletChatdelete,
    departmentindex,
} from "@/api/manage";

// table表格数据配置
export default {
    data() {
        return {
            loading: false,
            departmentlist: [],
            params: {
                keywords: "",
                department_id: undefined,
                start_time: "",
                end_time: "",
            },
            dateaskDatas: [],
            pagination: { total: 0, pageSize: 10, current: 1 },
            data: [],
            columns: [
                {
                    title: "弹幕内容",
                    dataIndex: "bullet_chat",
                    ellipsis: true,
                    width: "60%",
                },
                {
                    title: "所属部门",
                    dataIndex: "name",
                    width: "10%",
                },
                {
                    title: "姓名",
                    dataIndex: "user",
                    width: "8%",
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: "17%",
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "status" },
                    width: "5%",
                },
            ],
        };
    },
    mounted() {
        this.initial();
    },
    methods: {
        initial() {
            this.askData();
            this.department();
        },
        askData() {
            this.loading = true;
            let params = {
                page: this.pagination.current,
                pageSize: this.pagination.pageSize,
                keywords: this.params.keywords ? this.params.keywords : "",
                department_id: this.params.department_id
                    ? this.params.department_id
                    : "",
                start_time: this.params.start_time,
                end_time: this.params.end_time,
            };
            return bulletChatindex(params).then((res) => {
                this.loading = false;
                this.data = res.result.list;
                this.pagination.total = res.result.total;
                // console.log(this.pagination);
            });
        },
        askDatas() {
            this.pagination.current = 1
            this.params.department_id = undefined;
            this.params.start_time = "";
            this.params.end_time = "";
            this.askData();
        },
        askDataing() {
            this.pagination.current = 1
            this.askData();
        },
        dateaskData(e, es) {
            this.pagination.current = 1
            this.params.start_time = es[0];
            this.params.end_time = es[1];
            this.askData();
        },
        handleTableChange(pagination) {
            this.pagination = pagination;
            this.askData();
        },
        department() {
            return departmentindex().then((res) => {
                this.departmentlist = res.result
            });
        },
        clickdel(record) {
            this.$confirm({
                title: "确定删除当前弹幕?",
                content: "",
                okText: "删除",
                okType: "danger",
                cancelText: "取消",
                onOk: () => {
                    return bulletChatdelete({
                        id: record.id,
                    }).then((res) => {
                        this.$message.success(res.msg);
                        this.askData();
                    });
                },
                onCancel() {
                    console.log("Cancel");
                },
            });
        },
    },
};
</script>
